<template>
  <v-expansion-panels
          class="mb-4"
  >
    <v-expansion-panel>
      <v-expansion-panel-header>Tìm kiếm giao dịch</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card
                class="ma-0"
                outlined
        >
          <v-list-item class="pa-0" three-line>
            <v-list-item-content class="pa-0">
              <v-row>
                <v-col
                        cols="12"
                        sm="6"
                >
                  <v-text-field
                          v-model="filterForm.keyword"
                          label="Tìm kiếm"
                          placeholder="Tìm kiếm theo tên, mô tả..."
                          clearable
                          @keyup.enter="searchDepartment"
                  />
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                >
<!--                  <v-autocomplete-->
<!--                          v-model="filterForm.schoolLevelIds"-->
<!--                          :items=""-->
<!--                          item-value="id"-->
<!--                          item-text="name"-->
<!--                          label="Tìm kiếm nhóm ngành"-->
<!--                          placeholder="Chọn nhóm ngành"-->
<!--                          clearable-->
<!--                          multiple-->
<!--                  />-->
                </v-col>
              </v-row>
              <div class="text-center mb-4">
                <v-btn
                        class="primary mx-0"
                        @click="searchDepartment"
                >
                  <v-icon>mdi-magnify</v-icon>Tìm kiếm
                </v-btn>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
  export default {
    name: 'FilterForm',
    props: {
      filterForm: {
        default: () => ({}),
      }
    },
    data () {
      return {
        departments: [],
      }
    },
    created () {
    },
    methods: {
      searchDepartment () {
        Bus.$emit('transaction-history-filter', this.filterForm)
      },
    },
  }
</script>
